import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const VariantIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props} viewboxSize="xl">
      <path d="M24 19h-5v5h5v-5Z" />
      <path d="M4 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm2 0v9h9V6H6Zm11 9h9V6h-9v9ZM6 17v9h9v-9H6Zm20 9v-9h-9v9h9Z" />
    </BaseIcon>
  );
};
